<template>
      <div class="Maintemplate">
        <v-app class="app-shell">
        <MenuHeader></MenuHeader>
        <v-main>
          <v-container fluid>
            <router-view></router-view>
          </v-container>
        </v-main>
        <!-- <Footer></Footer> -->
        </v-app>
      </div>
</template>
<script>
import MenuHeader from '@/components/MenuHeader/MenuHeader'
// import Footer from '@/components/Footer/Footer'
export default {
    name:'Maintemplate',
    components: {
      MenuHeader,
      // Footer
    },
    setup() {

    },
}
</script>

<style scoped>
/* Latar seluruh aplikasi (dahulu: `background: #EEEEEE` sebaris pada <v-app>).

   PENTING — kenapa dicat pada `.v-application--wrap` dan bukan `.v-application`:
   belasan halaman kemasukan data (hk2, hk3, JR2, IMBANGAN, …) mengisytiharkan
   `#app { background: url(HIES.jpg) … !important }` dalam blok <style> TANPA
   `scoped`. Peraturan itu GLOBAL: sebaik sahaja mana-mana halaman itu dimuatkan,
   ia kekal dan mengecat `#app` — bekas LUAR bagi `.v-application` — pada setiap
   halaman. Jadi latar pada `.v-application` tertimbus di bawah foto tersebut.
   `.v-application--wrap` berada DI ATAS `#app` dan Vuetify tidak memberinya
   sebarang latar, jadi mengecat di sini menang tanpa perlu melawan `!important`
   halaman lain. Ia juga tidak menyentuh skrin log masuk (publictemplate
   mempunyai <v-app> sendiri). */
/* KENAPA latar diletak pada lapisan `position: fixed` dan BUKAN terus pada
   `.v-application--wrap`: elemen itu hanya setinggi kandungannya, jadi pada
   halaman panjang kecerunan akan tamat dan meninggalkan ruang kosong apabila
   ditatal. Lapisan `fixed` sentiasa menutupi seluruh viewport, jadi latar
   kelihatan "tidak berpenghujung" tidak kira sepanjang mana halaman itu. */
.app-shell ::v-deep .v-application--wrap {
  position: relative;
  background: transparent;
}

/* Lapisan 1 — kecerunan warna:
       1. cahaya radial mint di kanan atas
       2. cahaya radial teal pekat di kiri bawah
       3. cahaya radial amber suam di tengah kanan (memecah nada sejuk)
       4. cahaya radial biru-navy di kiri atas (menambah kedalaman)
       5. kecerunan asas teal pucat → hijau kelabu
     Kad kandungan berwarna putih pekat, jadi latar boleh lebih bertenaga
     tanpa menjejaskan kebolehbacaan jadual & carta di atasnya. */
.app-shell ::v-deep .v-application--wrap::before {
  content: '';
  position: fixed;
  inset: 0;
  z-index: 0;
  pointer-events: none;
  background:
    radial-gradient(1100px 620px at 96% -6%, rgba(95, 227, 211, .42), transparent 60%),
    radial-gradient(950px 600px at -8% 106%, rgba(3, 119, 105, .28), transparent 58%),
    radial-gradient(760px 500px at 74% 66%, rgba(224, 168, 0, .16), transparent 62%),
    radial-gradient(820px 520px at 4% -8%, rgba(11, 31, 58, .10), transparent 56%),
    linear-gradient(160deg, #eaf6f4 0%, #dceeeb 40%, #cfe6e2 72%, #c6e0dc 100%);
}

/* Lapisan 2 — komposisi TUNGGAL "jabatan perangkaan" (bukan jubin berulang).
   Satu adegan 1600x900 dilukis SEKALI dan diskala "cover" — carta bar, garis
   aliran dengan titik data, lengkung taburan normal, taburan titik, dan carta
   donut — disusun secara asimetri seperti muka depan laporan statistik.

   "background-repeat: no-repeat" — corak berjubin sentiasa kelihatan seperti
   kertas dinding; komposisi tunggal kelihatan seperti reka bentuk sebenar.

   Topeng radial ("mask") melembutkan bahagian TENGAH tempat kad kandungan
   duduk, jadi grafik hanya menonjol di birai skrin.

   Nota data-URI: "#" MESTI "%23", "<" / ">" MESTI "%3C" / "%3E", dan "%"
   dalam nilai (cth. "50%") MESTI "%25". Jika tidak, URL terpotong dan imej
   gagal dimuatkan secara SENYAP — binaan tetap "berjaya".

   Arka donut r=120 (C~754.0): dasharray = [arka, C - arka].
     teal  301.6 / 452.4 = 40%
     amber 113.1 / 640.9 = 15%
   Jika baki salah, arka akan berulang mengelilingi bulatan. */
.app-shell ::v-deep .v-application--wrap::after {
  content: '';
  position: fixed;
  inset: 0;
  z-index: 0;
  pointer-events: none;
  opacity: .9;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='1600' height='900' viewBox='0 0 1600 900' preserveAspectRatio='xMidYMid slice'%3E%3Cdefs%3E%3ClinearGradient id='sBar' x1='0' y1='1' x2='0' y2='0'%3E%3Cstop offset='0%25' stop-color='%23037769' stop-opacity='.02'/%3E%3Cstop offset='100%25' stop-color='%230EA5A4' stop-opacity='.16'/%3E%3C/linearGradient%3E%3ClinearGradient id='sArea' x1='0' y1='0' x2='0' y2='1'%3E%3Cstop offset='0%25' stop-color='%230EA5A4' stop-opacity='.13'/%3E%3Cstop offset='100%25' stop-color='%230EA5A4' stop-opacity='0'/%3E%3C/linearGradient%3E%3CradialGradient id='sFade' cx='50%25' cy='48%25' r='58%25'%3E%3Cstop offset='0%25' stop-color='%23000' stop-opacity='1'/%3E%3Cstop offset='55%25' stop-color='%23000' stop-opacity='.55'/%3E%3Cstop offset='100%25' stop-color='%23000' stop-opacity='0'/%3E%3C/radialGradient%3E%3Cmask id='mFade'%3E%3Crect width='1600' height='900' fill='%23fff'/%3E%3Crect width='1600' height='900' fill='url(%23sFade)'/%3E%3C/mask%3E%3C/defs%3E%3Cg mask='url(%23mFade)'%3E%3Cg stroke='%23026254' stroke-opacity='.05' stroke-width='1' fill='none'%3E%3Cpath d='M0 180h1600M0 360h1600M0 540h1600M0 720h1600'/%3E%3C/g%3E%3Cg fill='url(%23sBar)'%3E%3Crect x='70' y='560' width='46' height='300'/%3E%3Crect x='136' y='470' width='46' height='390'/%3E%3Crect x='202' y='620' width='46' height='240'/%3E%3Crect x='268' y='400' width='46' height='460'/%3E%3Crect x='334' y='520' width='46' height='340'/%3E%3Crect x='400' y='330' width='46' height='530'/%3E%3C/g%3E%3Cpath d='M980 300 L1100 210 L1220 260 L1340 140 L1460 190 L1580 110 L1600 120 L1600 480 L980 480 Z' fill='url(%23sArea)'/%3E%3Cpolyline points='980,300 1100,210 1220,260 1340,140 1460,190 1580,110' fill='none' stroke='%230EA5A4' stroke-opacity='.30' stroke-width='3' stroke-linecap='round' stroke-linejoin='round'/%3E%3Cg fill='%23026254' fill-opacity='.24'%3E%3Ccircle cx='1100' cy='210' r='6'/%3E%3Ccircle cx='1340' cy='140' r='6'/%3E%3Ccircle cx='1580' cy='110' r='6'/%3E%3C/g%3E%3Cg fill='none' stroke='%23037769' stroke-opacity='.16' stroke-width='2.5'%3E%3Cpath d='M120 240c60 0 60-150 120-150s60 150 120 150'/%3E%3C/g%3E%3Cg fill='%230EA5A4' fill-opacity='.14'%3E%3Ccircle cx='700' cy='690' r='9'/%3E%3Ccircle cx='760' cy='740' r='6'/%3E%3Ccircle cx='660' cy='780' r='7'/%3E%3Ccircle cx='800' cy='660' r='5'/%3E%3Ccircle cx='730' cy='820' r='8'/%3E%3C/g%3E%3Cg fill='none' stroke-width='26' stroke-linecap='butt'%3E%3Ccircle cx='1330' cy='690' r='120' stroke='%23026254' stroke-opacity='.05'/%3E%3Ccircle cx='1330' cy='690' r='120' stroke='%230EA5A4' stroke-opacity='.14' stroke-dasharray='301.6 452.4' transform='rotate(-90 1330 690)'/%3E%3Ccircle cx='1330' cy='690' r='120' stroke='%23E0A800' stroke-opacity='.10' stroke-dasharray='113.1 640.9' transform='rotate(54 1330 690)'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: center center;
  background-size: cover;
}

/* Kandungan mesti di atas lapisan corak. */
.app-shell ::v-deep .v-main {
  position: relative;
  z-index: 1;
}
</style>